import { mapState } from 'vuex';

export default {
    data() {
        return {
            contador: 2,
            active: 0,
            subActive: 0,
            tablaPrecios: {
                ccf: 0,
                afp: 0,
                aflCcf: 0,
                aflAfp: 0,
                exonerado: {
                    eps: 0,
                    r1: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        }
                    },
                    r2: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    },
                    r3: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    },
                    r4: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    },
                    r5: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    }
                },
                noexonerado: {
                    eps: 0,
                    r1: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        }
                    },
                    r2: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    },
                    r3: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    },
                    r4: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    },
                    r5: {
                        value: 0,
                        afiliacion: 0,
                        epsarl: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccf: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                        epsarlccfafp: {
                            admin: 0,
                            value: 0,
                            aporte: 0
                        },
                    }
                }
            },
            salarioBase: null,
            preciosBase: [],
            updateAfiliados: false,
        }
    },
    async created() {
        let preciosBase = await this.buscarIdb({ tabla: 'base', campo: 'id', value: 1 })
        if (preciosBase.length > 0) {
            await this.updateDataForm({ state: 'base', data: preciosBase[0] })
            this.salarioBase = preciosBase[0].base
        }

        this.preciosBase = await this.buscarIdb({ tabla: 'precios', campo: 'id_datos_contacto', value: 1 })

        await this.updateDataForm({ state: 'precios', data: this.preciosBase })

        if (this.dataForm[this.namePath].precios.length > 0) {

            let preciosExonerado = _.filter(this.dataForm[this.namePath].precios, ['exonerado', 1])
            for (let i = 0; i < preciosExonerado.length; i++) {
                this.tablaPrecios.aflCcf = preciosExonerado[i].aflccf
                this.tablaPrecios.aflAfp = preciosExonerado[i].aflafp
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].afiliacion = preciosExonerado[i].afleps
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarl.admin = preciosExonerado[i].epsarl
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarl.aporte = preciosExonerado[i].epsarl - this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarl.admin
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlccf.admin = preciosExonerado[i].epsarlccf
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlccf.aporte = preciosExonerado[i].epsarlccf - this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlccf.admin
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlafp.admin = preciosExonerado[i].epsarlafp
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlafp.aporte = preciosExonerado[i].epsarlafp - this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlafp.admin
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlccfafp.admin = preciosExonerado[i].epsarlccfafp
                this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlccfafp.aporte = preciosExonerado[i].epsarlccfafp - this.tablaPrecios.exonerado['r' + preciosExonerado[i].id_list_riesgo].epsarlccfafp.admin
            }
            let preciosNoExonerado = _.filter(this.dataForm[this.namePath].precios, ['exonerado', 0])
            for (let i = 0; i < preciosNoExonerado.length; i++) {
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].afiliacion = preciosNoExonerado[i].afleps
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarl.admin = preciosNoExonerado[i].epsarl
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarl.aporte = preciosNoExonerado[i].epsarl - this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarl.admin
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlccf.admin = preciosNoExonerado[i].epsarlccf
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlccf.aporte = preciosNoExonerado[i].epsarlccf - this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlccf.admin
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlafp.admin = preciosNoExonerado[i].epsarlafp
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlafp.aporte = preciosNoExonerado[i].epsarlafp - this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlafp.admin
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlccfafp.admin = preciosNoExonerado[i].epsarlccfafp
                this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlccfafp.aporte = preciosNoExonerado[i].epsarlccfafp - this.tablaPrecios.noexonerado['r' + preciosNoExonerado[i].id_list_riesgo].epsarlccfafp.admin
            }
        }

        await this.changePrice()

        this.contador = 1

    },
}